/**
 * Basic implementation of `EventTarget` for non-DOM (non-bubbling) usage.
 */
export abstract class SimpleEvents implements EventTarget {
    private listeners: { [key: string]: EventListenerOrEventListenerObject[] } = {}

    public addEventListener(type: string, listener: EventListenerOrEventListenerObject) {
        this.listeners[type] = this.listeners[type] || []
        this.listeners[type].push(listener)

        // make chainable
        return this
    }

    public dispatchEvent(event: Event) {
        try {
            (this.listeners[event.type] || []).forEach((listener) =>
                'handleEvent' in listener ? listener.handleEvent(event) : listener(event))
            return true
        } catch (e) {
            return false
        }
    }

    public removeEventListener(type: string, listener: EventListenerOrEventListenerObject): void {
        const index = (this.listeners[type] || []).indexOf(listener)
        if (index >= 0) {
            this.listeners[type].splice(index, 1)
        }
    }
}
